module.exports = __webpack_public_path__ + "img/design.576d236d.png";